import { HTMLAttributes } from 'react'
import { BoxWrapper } from './Styled'

function Box(props: HTMLAttributes<HTMLDivElement | HTMLSpanElement>): JSX.Element {
  return <BoxWrapper {...props}>{props.children}</BoxWrapper>
}

export default Box
